$(document).ready(function () {
  // Open flip box
  $('.icon-with-text-flip-box .open-flip-box').on('click', function () {
    $(this).closest('.icon-with-text-flip-box').find('.icon-flip-box').addClass('active');
  });

  // Close flip box
  $('.icon-with-text-flip-box .close-flip-box').on('click', function () {
    $(this).closest('.icon-with-text-flip-box').find('.icon-flip-box').removeClass('active');
  });
});

var flickityInstance = null;

function initFlickityIfMobile() {
  var selectors = [
    '.twobglass-icons .icon-text-container',
    '.about-icon-text-box .icon-text-container'
  ];

  var container = null;

  for (var i = 0; i < selectors.length; i++) {
    var el = document.querySelector(selectors[i]);
    if (el) {
      container = el;
      break;
    }
  }

  if (!container) return;

  var screenWidth = window.innerWidth;

  if (screenWidth < 1025) {
    if (!container.classList.contains('flickity-enabled')) {
      flickityInstance = new Flickity(container, {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: true,
        wrapAround: true,
        autoPlay: 5000,
        pauseAutoPlayOnHover: false
      });
    }
  } else {
    if (container.classList.contains('flickity-enabled')) {
      flickityInstance.destroy();
    }
  }
}

initFlickityIfMobile();

window.addEventListener('resize', initFlickityIfMobile);
